// FNP-1248 — labels and basePath every navigate/link in the module references,
// so a route rename is one edit rather than a grep.
// FNP-1301 — the tenant-facing page showing the trust policy and the
// permission policy in full. Two surfaces link to it, so the URL lives here
// rather than as a literal in each.
export const CONNECT_PROVIDER_DOCS_URL =
    'https://docs.flexi.domains/connect-a-dns-provider.html';

export default {
    entityKey: 'provider-connections',
    basePath: '/provider-connections',
    titles: {
        singular: 'Provider Connection',
        plural: 'Provider Connections',
    },
};
